import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';

import { withStyles, createStyles } from '@material-ui/core/styles';

import { grey } from '@material-ui/core/colors';
import {
	blackColor,
	dangerColor,
	grayColor,
	primaryColor,
	primarySkyColor,
	whiteColor,
} from 'assets/jss/material-dashboard-pro-react';

const padding = '15px 24px';

const styles = (theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: whiteColor,
	},
	accordionTitle: {
		fontSize: theme.fontSize(18),
		display: 'flex',
	},
	helpIcon: {
		fill: blackColor,
		margin: 'auto 15px',
	},
	accordionTitleContainer: {
		borderBottom: 'none',
		borderTopLeftRadius: '4px',
		borderTopRightRadius: '4px',
	},
	accordionElement: {
		display: 'flex',
	},
	accordionElementLabel: {
		width: '100%',
		margin: 'auto',
		marginLeft: 16,
		cursor: 'pointer',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
	},
	paymentMethodWrapper: {
		width: '100%',
	},
	cardDetailsContainer: {
		width: '100%',
		display: 'flex',
		padding: padding,
		justifyContent: 'space-between',
		borderBottom: `1px solid ${grayColor[27]}`,
	},
	cardDetailTitle: {
		marginTop: 0,
		fontWeight: 400,
		color: grayColor[28],
		textTransform: 'capitalize',
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
		fontFamily: theme.fontFamily.albert.bold + ' !important',
	},
	cardChangeActionContainer: {
		display: 'block',
	},
	cardChangeActionText: {
		color: primaryColor[0],
		fontWeight: '700',
		textTransform: 'capitalize',
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
		fontFamily: theme.fontFamily.albert.bold + ' !important',
		cursor: 'pointer',
		margin: 0,
	},
	billDetailsContainer: {
		padding: padding,
	},
	billingEmailInput: { margin: '0 !important' },
	makePaymentButton: {
		fontFamily: theme.fontFamily.albert.bold + ' !important',
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
	},
	buttonDisabled: {
		backgroundColor: grayColor[27],
		color: whiteColor,
	},
	infoNote: {
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
		marginBottom: 0,
	},
	switchLabel: {
		color: blackColor,
		margin: '0px',
		fontFamily: `${theme.fontFamily.albert.bold} !important`,
		'& .MuiFormControlLabel-label': {
			fontSize: theme.fontSize(12),
			margin: '0px 8px',
		},
	},
	termConditionText: {
		display: 'flex',
		color: blackColor,
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(0.5),
		color: theme.palette.grey[500],
	},
	termConditionTextAction: {
		color: primaryColor[0],
		margin: '0px 5px',
	},
	bottomSpace: {
		marginBottom: '16px',
	},
	borderBottomNone: {
		borderBottom: '0px',
	},
	popover: {
		pointerEvents: 'none',
	},
	paper: {
		padding: theme.spacing(1),
		background: blackColor,
	},
	securePaymentContainer: {
		margin: '24px auto',
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
	},
	securePaymentHeading: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	securePaymentText: {
		margin: '0px 14px',
		fontWeight: 700,
	},
	paddingNone: {
		padding: 0,
	},
	paddingBottomNone: {
		paddingBottom: 0,
	},
	orderSummaryText: {
		margin: '3px 0px',
	},
	orderSummaryList: {},
	orderSummaryItem: {
		padding: padding,
		borderBottom: `1px solid ${grayColor[27]}`,
	},
	orderSummaryContent: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	orderSummarySubContent: {
		paddingLeft: '16px',
	},
	marginBottomNone: {
		marginBottom: '0px !important',
	},
	textRight: {
		marginLeft: 'auto',
	},
	boxShadowNone: {
		boxShadow: 'none',
	},
	bankAliasContainer: {
		display: 'flex',
		justifyContent: 'start',
		alignItems: 'center',
	},
	bankAliasToggleButton: {
		background: 'transparent',
		border: 'none',
	},
	bankAliasEyeIcon: {
		cursor: 'pointer',
		margin: 'auto 10px',
	},
	dialogFooter: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	paymentRejectedBody: {
		marginBottom: 60,
	},
	bankIntroDialogContent: { padding: 0 },
	DarkHeading: {
		background: grayColor[1],
		margin: '0px -24px',
		padding: padding,
	},
	introSlideWrapper: {},
	introSlide: {
		width: '100%',
	},
	introPagination: { justifyContent: 'center', background: whiteColor },
	introMedia: {
		width: '100%',
		margin: '24px auto',
		'& > *': {
			width: '100%',
			borderRadius: '8px',
		},
	},
	paymentNote: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	cardWrapper: {
		width: '100%',
	},
	cardItem: {
		alignItems: 'center',
		['& .MuiFormControlLabel-label']: {
			fontSize: theme.fontSize(17),
			color: grayColor[29],
		},
		['& .MuiRadio-colorSecondary']: {
			color: primaryColor[0],
		},
	},
	addCardButton: {
		width: '100%',
		maxWidth: '250px',
		minWidth: '180px',
		fontWeight: '400',
	},
	deleteAction: {
		color: dangerColor[7],
		fontSize: theme.fontSize(13),
		fontWeight: 700,
		cursor: 'pointer',
		textDecorationLine: 'underline',
		background: 'transparent',
		border: 'none',
		fontFamily: theme.fontFamily.albert.bold + ' !important',
	},
	addCardDialog: {
		paddingLeft: '0px',
		paddingRight: '0px',
	},
	addCardDialogFooter: {
		gap: '16px',
		display: 'flex',
		justifyContent: 'end',
	},
	link: {
		color: primarySkyColor,
		textDecorationLine: 'underline',
	},
});
export const CustomeCheckbox = withStyles({
	root: {
		color: grey[400],
		marginLeft: '0px',
		marginTop: '0px',
		'&$checked': {
			color: grey[600],
		},
	},
	checked: {},
})(Checkbox);

export const AntSwitch = withStyles((theme) =>
	createStyles({
		root: {
			width: 28,
			height: 16,
			padding: 0,
			display: 'flex',
		},
		switchBase: {
			padding: 2,
			color: theme.palette.grey[500],
			'&$checked': {
				transform: 'translateX(12px)',
				color: theme.palette.common.white,
				'& + $track': {
					opacity: 1,
					backgroundColor: theme.palette.primary.main,
					borderColor: theme.palette.primary.main,
				},
			},
		},
		thumb: {
			width: 12,
			height: 12,
			boxShadow: 'none',
		},
		track: {
			border: `1px solid ${theme.palette.grey[500]}`,
			borderRadius: 16 / 2,
			opacity: 1,
			backgroundColor: theme.palette.common.white,
		},
		checked: {},
	})
)(Switch);

export default styles;
